import React, { useState, useContext } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Tooltip,
  Grid,
  useMediaQuery,
  Tab,
  Tabs,
  Paper,
} from "@mui/material";
import ApiPaginateSearch from "../../component/ApiPaginateSearch";
import { CustomStyles } from "../../component/CustomStyle";
import ApiEndpoints from "../../network/ApiEndPoints";
import AddSalary from ".././Biggbarains/AddSalary";
import EditSalary from ".././Biggbarains/EditSalary";
// import SalaryComponents from "./Biggbarains/SalaryComponents";÷
// import SalarySlips from "/././Biggbarains/SalarySlips";
import CachedIcon from "@mui/icons-material/Cached";
import DeleteIcon from "@mui/icons-material/Delete";
import ReceiptIcon from "@mui/icons-material/Receipt";
import BuildIcon from "@mui/icons-material/Build";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import { apiErrorToast, okSuccessToast } from "../../utils/ToastUtil";
import { postJsonData } from "../../network/ApiController";
import AuthContext from "../../store/AuthContext";
import SalarySlips from "./SalarySlips";
import SalaryComponents from "./SalaryComponents";

let refresh;

// Tab Panel component
function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`salary-tabpanel-${index}`}
      aria-labelledby={`salary-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
    </div>
  );
}

export const Salary = () => {
  const [apiData, setApiData] = useState([]);
  const [query, setQuery] = useState("");
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [tabValue, setTabValue] = useState(0);
  const authCtx = useContext(AuthContext);
  const user = authCtx?.user;
  const isSmallScreen = useMediaQuery("(max-width:600px)");

  const refreshFunc = () => {
    setQuery("");
    refresh?.();
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleOpenDelete = (salary) => {
    setSelectedSalary(salary);
    setDeleteModalOpen(true);
  };

  const handleDeleteSalary = () => {
    if (!selectedSalary) return;
    postJsonData(
      ApiEndpoints.DELETE_SALARY,
      { id: selectedSalary.id },
      () => {},
      (response) => {
        okSuccessToast(response.data.message);
        setDeleteModalOpen(false);
        refresh && refresh();
      },
      (error) => {
        apiErrorToast(error.message || "Error deleting salary.");
      }
    );
  };

  const columns = [
    {
      name: "Employee ID",
      selector: (row) => row.emp_id || row.user_id,
      sortable: true,
    },
    {
      name: "Name",
      selector: (row) => row.emp_name || row.user?.name || "N/A",
      sortable: true,
    },
    {
      name: "Department",
      selector: (row) => row.department || row.user?.department || "N/A",
      sortable: true,
    },
    {
      name: "Designation",
      selector: (row) => row.user?.role || "Employee",
      sortable: true,
    },
    {
      name: "CTC (₹)",
      selector: (row) => 
        new Intl.NumberFormat('en-IN', {
          style: 'currency',
          currency: 'INR',
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        }).format(row.ctc || row.amount || 0),
      sortable: true,
    },
    {
      name: "Effective From",
      selector: (row) => row.effective_from ? new Date(row.effective_from).toLocaleDateString() : "N/A",
      sortable: true,
    },
    {
      name: "Actions",
      selector: (row) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <EditSalary salary={row} onSuccess={() => refresh && refresh()} />
          <Tooltip title="View Salary Slips">
            <IconButton
              color="info"
              size="small"
              onClick={() => {
                setTabValue(2); // Switch to Salary Slips tab
                // You might want to pass the user_id to filter slips
              }}
            >
              <ReceiptIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Delete Salary">
            <IconButton
              color="error"
              size="small"
              onClick={() => handleOpenDelete(row)}
            >
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </Box>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
    },
  ];

  return (
    <Box sx={{ width: '100%' }}>
      {/* Tabs Navigation */}
      <Paper sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs 
          value={tabValue} 
          onChange={handleTabChange}
          variant={isSmallScreen ? "scrollable" : "standard"}
          scrollButtons={isSmallScreen ? "auto" : false}
        >
          <Tab 
            icon={<AttachMoneyIcon />} 
            label="Salaries" 
            iconPosition="start"
          />
          <Tab 
            icon={<BuildIcon />} 
            label="Components" 
            iconPosition="start"
          />
          <Tab 
            icon={<ReceiptIcon />} 
            label="Salary Slips" 
            iconPosition="start"
          />
        </Tabs>
      </Paper>

      {/* Salaries Tab */}
      <TabPanel value={tabValue} index={0}>
        <Box
          sx={{
            mt: 3,
            overflow: isSmallScreen ? "auto" : "visible",
            maxHeight: isSmallScreen ? "90vh" : "none",
          }}
        >
          <Grid
            container
            alignItems="center"
            justifyContent="flex-end"
            sx={{ position: "relative", mb: 2 }}
          >
            <Grid
              item
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                overflowX: isSmallScreen ? "auto" : "visible",
                whiteSpace: "nowrap",
                paddingBottom: isSmallScreen ? 1 : 0,
              }}
            >
              {user?.role === "Admin" && (
                <AddSalary onSuccess={() => refresh && refresh()} />
              )}
              <Tooltip title="Refresh">
                <IconButton
                  aria-label="refresh"
                  sx={{ color: "#0F52BA" }}
                  onClick={refreshFunc}
                >
                  <CachedIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>
          <Grid>
            <ApiPaginateSearch
              apiEnd={ApiEndpoints.GET_SALARY}
              columns={columns}
              pagename={"Employee Salaries"}
              apiData={apiData}
              setApiData={setApiData}
              refresh={refreshFunc}
              tableStyle={CustomStyles}
              queryParam={query ? query : ""}
              returnRefetch={(ref) => {
                refresh = ref;
              }}
            />
          </Grid>
        </Box>
      </TabPanel>

      {/* Components Tab */}
      <TabPanel value={tabValue} index={1}>
        <SalaryComponents/>
      </TabPanel>

      {/* Salary Slips Tab */}
      <TabPanel value={tabValue} index={2}>
        <SalarySlips />
      </TabPanel>

      {/* Delete Confirmation Modal */}
      <Dialog open={deleteModalOpen} onClose={() => setDeleteModalOpen(false)}>
        <DialogTitle>Delete Salary</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete salary for{" "}
            {selectedSalary?.emp_name}? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteModalOpen(false)}>Cancel</Button>
          <Button color="error" onClick={handleDeleteSalary}>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};